import { DateTime } from 'luxon';
import { cn } from '@Utils/cn';
import type { ShiftReportSummary } from '@Types/shiftReport';

function dayLabel(iso: string): string {
  const dt = DateTime.fromISO(iso);
  if (!dt.isValid) return '';
  const cal = dt.toRelativeCalendar(); // "today" | "yesterday" | "3 days ago"
  const label = cal ? cal.charAt(0).toUpperCase() + cal.slice(1) : '';
  return `${label} · ${dt.toFormat('t')}`;
}

interface Props {
  report: ShiftReportSummary;
  onOpen: () => void;
}

export default function ShiftReportCard({ report, onOpen }: Props) {
  return (
    <button
      type="button"
      onClick={onOpen}
      className={cn(
        'block w-full rounded-xl border border-zinc-200 bg-white p-4 text-left shadow-sm transition',
        'hover:-translate-y-0.5 hover:border-zinc-300 hover:shadow-md',
        report.isNew && 'agent-shimmer ring-1 ring-amber-200',
      )}
    >
      <div className="flex items-center justify-between gap-3 text-xs text-zinc-500">
        <span className="flex items-center gap-2">
          <span className="font-medium text-zinc-600">
            {report.venueName} · {report.guestCount}{' '}
            {report.guestCount === 1 ? 'guest' : 'guests'}
          </span>
          {report.isNew && (
            <span className="rounded-full bg-amber-100 px-2 py-0.5 text-[10px] font-bold tracking-wide text-amber-700 uppercase">
              New
            </span>
          )}
        </span>
        <span className="whitespace-nowrap">{dayLabel(report.shiftDate)}</span>
      </div>

      {/* the report's headline, framed as one of the agent's thoughts */}
      <p className="mt-2 flex gap-2 text-sm leading-relaxed text-zinc-800">
        <span aria-hidden className="mt-0.5 shrink-0">
          💭
        </span>
        <span>{report.highlight}</span>
      </p>
    </button>
  );
}
